import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThuHoi } from "./ModalThuHoi";

export const BtnThuHoi = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Thu hồi"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
         <img src="/app-assets/images/icon-thu-hoi-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ModalThuHoi
          show={show}
          onHide={handleClose}
          taisanId={item.TaiSanID}
        />
      )}
    </>
  );
};
